/**
 * @generated SignedSource<<51a35283eac1d4f4e50d5550518c5658>>
 * @relayHash feae64578b0a3fba44f22230201969bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272

import type { ConcreteRequest, Query } from 'relay-runtime';
export type RecommendedPagesSpaceBehavior = "HIDDEN" | "SHOWN" | "%future added value";
export type EndOfPageRecommendationQuery$variables = {
  exp: string;
  id: string;
  key: string;
  keyString: string;
  type: string;
};
export type EndOfPageRecommendationQuery$data = {
  readonly getRecommendedPages: {
    readonly recommendedPages: ReadonlyArray<{
      readonly content: {
        readonly creatorId: string | null | undefined;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly history: {
          readonly ownedBy: {
            readonly displayName: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly space: {
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly strategy: ReadonlyArray<string>;
    }>;
    readonly status: {
      readonly isEnabled: boolean;
      readonly userCanToggle: boolean;
    };
  } | null | undefined;
  readonly getRecommendedPagesSpaceStatus: {
    readonly defaultBehavior: RecommendedPagesSpaceBehavior;
    readonly recommendedPagesEnabled: boolean;
  } | null | undefined;
  readonly space: {
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type EndOfPageRecommendationQuery = {
  response: EndOfPageRecommendationQuery$data;
  variables: EndOfPageRecommendationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "exp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keyString"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "keyString"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v7 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "entityType",
    "variableName": "type"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "exp"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "subType"
},
v11 = {
  "kind": "ScalarField",
  "name": "creatorId"
},
v12 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v16 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v14/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v17 = {
  "kind": "ScalarField",
  "name": "strategy"
},
v18 = {
  "concreteType": "RecommendedPagesStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "userCanToggle"
    },
    {
      "kind": "ScalarField",
      "name": "isEnabled"
    }
  ]
},
v19 = {
  "args": [
    {
      "kind": "Variable",
      "name": "entityId",
      "variableName": "key"
    }
  ],
  "concreteType": "RecommendedPagesSpaceStatus",
  "kind": "LinkedField",
  "name": "getRecommendedPagesSpaceStatus",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "recommendedPagesEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "defaultBehavior"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EndOfPageRecommendationQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "RecommendedPages",
        "kind": "LinkedField",
        "name": "getRecommendedPages",
        "plural": false,
        "selections": [
          {
            "concreteType": "RecommendedPagesItem",
            "kind": "LinkedField",
            "name": "recommendedPages",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          },
          (v18/*: any*/)
        ]
      },
      (v19/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "EndOfPageRecommendationQuery",
    "selections": [
      (v6/*: any*/),
      {
        "args": (v7/*: any*/),
        "concreteType": "RecommendedPages",
        "kind": "LinkedField",
        "name": "getRecommendedPages",
        "plural": false,
        "selections": [
          {
            "concreteType": "RecommendedPagesItem",
            "kind": "LinkedField",
            "name": "recommendedPages",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          },
          (v18/*: any*/)
        ]
      },
      (v19/*: any*/)
    ]
  },
  "params": {
    "cacheID": "feae64578b0a3fba44f22230201969bb",
    "id": "5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272",
    "metadata": {},
    "name": "EndOfPageRecommendationQuery",
    "operationKind": "query",
    "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
  }
};
})();

(node as any).hash = "89dc64ac31ebaadc798791741477c5f3";

export default node;
